
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"140","height":"140","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.125 113.75a4.375 4.375 0 01-4.375-4.375V78.75h-4.375a4.375 4.375 0 110-8.75h4.375a8.76 8.76 0 018.75 8.75v30.625a4.375 4.375 0 01-4.375 4.375z"}}),_c('path',{attrs:{"d":"M56.875 113.75h-17.5A4.375 4.375 0 0135 109.375 4.375 4.375 0 0139.375 105h17.5a4.375 4.375 0 014.375 4.375 4.375 4.375 0 01-4.375 4.375zM85.049 113.751a4.378 4.378 0 01-4.1-5.913l10.913-29.084H80.687a4.375 4.375 0 010-8.75h11.188a8.756 8.756 0 018.181 11.822l-10.91 29.089a4.377 4.377 0 01-4.097 2.836z"}}),_c('path',{attrs:{"d":"M13.125 17.5h113.75A13.14 13.14 0 01140 30.625v96.25A13.14 13.14 0 01126.875 140H13.125A13.14 13.14 0 010 126.875v-96.25A13.14 13.14 0 0113.125 17.5zm113.75 113.75a4.38 4.38 0 004.375-4.375v-96.25a4.38 4.38 0 00-4.375-4.375H13.125a4.38 4.38 0 00-4.375 4.375v96.25a4.38 4.38 0 004.375 4.375z"}}),_c('path',{attrs:{"d":"M135.625 61.25H4.375A4.375 4.375 0 010 56.875 4.375 4.375 0 014.375 52.5h131.25A4.375 4.375 0 01140 56.875a4.375 4.375 0 01-4.375 4.375zM39.375 39.375A4.375 4.375 0 0135 35V4.375A4.375 4.375 0 0139.375 0a4.375 4.375 0 014.375 4.375V35a4.375 4.375 0 01-4.375 4.375zM100.625 39.375A4.375 4.375 0 0196.25 35V4.375A4.375 4.375 0 01100.625 0 4.375 4.375 0 01105 4.375V35a4.375 4.375 0 01-4.375 4.375z"}})])
          )
        }
      }
    